var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#F06D22;stroke-width:2;}\n\t.st1{fill:none;stroke:#F06D22;stroke-width:1.5;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Press"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Press-4",
    transform: "translate(-1111.000000, -729.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(1124.000000, 742.000000) scale(1, -1) translate(-1124.000000, -742.000000) translate(1112.000000, 730.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "st0",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    className: "st1",
    points: "6.8,11.3 12,6.1 17.2,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    className: "st1",
    d: "M12,7.3v10.1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOrange);
export default __webpack_public_path__ + "static/media/arrow-down-orange.6d674832.svg";
export { ForwardRef as ReactComponent };